import zod from 'zod';

const ContactIdEvent = zod.object(
  {
    id: zod.number(),
    description: zod.string().min(1),
    code: zod.string().min(1),
  },
  { required_error: 'Obrigatório informar o evento.' },
);

export const VirtualAlarmCentralDeviceFormSchema = zod.object({
  id: zod.number().optional(),
  zone: zod
    .number({ required_error: 'Obrigatório preencher a zona.' })
    .min(1, 'Zona mínima permitida é 01.')
    .max(999, 'Zona máxima permitida é 999.'),
  name: zod.string().min(1),
  deviceId: zod.number({
    required_error: 'Obrigatório informar o dispositivo.',
  }),
  contactIdEventId: zod.number(),
  partitionId: zod.number({
    required_error: 'Obrigatório informar a partição.',
  }),
  deviceType: zod
    .enum([
      'LPR',
      'IVS',
      'FACIAL',
      'FACE_RECOGNITION',
      'TEMPERATURE_DETECTOR',
      'FACIAL_CONTROL',
      'TUYA',
      'DEFENSE',
      'DVR',
    ])
    .optional(),
});

export const PartitionFormSchema = zod.object({
  name: zod.string(),
  id: zod.number(),
  code: zod.number(),
  account: zod.string(),
  isArmed: zod.boolean(),
  // lastArmOrDisarm: zod.date().optional(),
});

export const VirtualAlarmCentralFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string().min(1, 'Campo obrigatório.'),
  account: zod.string().min(1, 'Campo obrigatório.'),
  isPartitionable: zod.boolean(),
  partitions: zod.array(PartitionFormSchema),
});
